import React, { useState, useEffect } from 'react';
import LoadingSpinner from '../components/LoadingSpinner';
import Comments from '../components/Comments';
import { FoodImage } from '../components/GameImages';
import '../css.css'

const FoodModal = ({ food, onClose }) => {
  if (!food) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>×</button>
        
        <div className="lure-detail">
          <div className="lure-main">
            <FoodImage 
              filename={food.filename}
              alt={food.foodname}
              className="lure-detail-image"
              onError={() => {
                console.warn('Failed to load food image:', food.filename);
              }}
            />
            <h2>{food.foodname}</h2>
          </div>
          
          <div className="lure-recipe">
            <h3>제작 재료</h3>
            
            {food.tools && food.tools.length > 0 && (
              <div className="recipe-section">
                <h4>필요 도구</h4>
                <div className="recipe-items">
                  {food.tools.map((tool, idx) => (
                    <div key={idx} className="recipe-item">
                      <FoodImage 
                        filename={tool.filename}
                        alt={tool.name}
                        className="recipe-item-image"
                        isIngredient={true}
                        onError={() => {
                          console.warn('Failed to load food tool image:', tool.filename);
                        }}
                      />
                      <span className="recipe-item-name">{tool.name}</span>
                      {tool.quantity > 1 && <span className="recipe-quantity">x{tool.quantity}</span>}
                    </div>
                  ))}
                </div>
              </div>
            )}
            
            {food.materials && food.materials.length > 0 && (
              <div className="recipe-section">
                <h4>필요 재료</h4>
                <div className="recipe-items">
                  {food.materials.map((material, idx) => (
                    <div key={idx} className="recipe-item">
                      <FoodImage 
                        filename={material.filename}
                        alt={material.name}
                        className="recipe-item-image"
                        isIngredient={true}
                        onError={() => {
                          console.warn('Failed to load food material image:', material.filename);
                        }}
                      />
                      <span className="recipe-item-name">{material.name}</span>
                      {material.quantity > 1 && <span className="recipe-quantity">x{material.quantity}</span>}
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const FoodTable = () => {
  const [foodData, setFoodData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedFood, setSelectedFood] = useState(null);
  const [modalLoading, setModalLoading] = useState(false);
  
  // 컴포넌트 마운트 시 데이터 로드
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch('/api/food');
        if (!response.ok) throw new Error('Network response was not ok');
        
        const data = await response.json();
        setFoodData(data);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching food data:', error);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleFoodClick = async (foodId) => {
    setModalLoading(true);
    
    try {
      const response = await fetch(`/api/food/${foodId}`);
      if (!response.ok) throw new Error('Network response was not ok');
      
      const data = await response.json();
      setSelectedFood(data);
    } catch (error) {
      console.error('Error fetching food details:', error);
    } finally {
      setModalLoading(false);
    }
  };

  const renderTable = () => {
    if (foodData.length === 0) return null;

    return (
      <div className="lure-grid">
        {foodData.map((food) => (
          <div key={food.id} className="lure-tile" onClick={() => handleFoodClick(food.id)}>
            <FoodImage 
              filename={food.filename}
              alt={food.foodname}
              className="lure-tile-image"
              onError={() => {
                console.warn('Failed to load food image:', food.filename);
              }}
            />
            <div className="lure-tile-name">{food.foodname}</div>
          </div>
        ))}
      </div>
    );
  };

  return (
    <>
      <h1 className="page-title">음식 정보</h1>
      <div>
        {loading ? (
          <div className="spinner-container">
            <LoadingSpinner
              height={80}
              width={80}
              color="#4fa94d"
              visible={true}
            />
          </div>
        ) : (
          <div className="page-content">
            {renderTable()}
          </div>
        )}
        
        {selectedFood && (
          <FoodModal 
            food={selectedFood} 
            onClose={() => setSelectedFood(null)} 
          />
        )}
        
        {modalLoading && (
          <div className="modal-overlay">
            <div className="spinner-container">
              <LoadingSpinner
                height={80}
                width={80}
                color="#4fa94d"
                visible={true}
              />
            </div>
          </div>
        )}
        
        <Comments pageName="food" />
      </div>
    </>
  );
};

export default FoodTable;
